export const ENODE_SUPPORTED_INVERTER_VENDORS = [
    // "AFORE",
    // "APSYSTEMS",
    // "CSISolar",
    // "Deye",
    "ENPHASE",
    // "FOXESS",
    "FRONIUS",
    // "GIVENERGY",
    "GOODWE",
    "GROWATT",
    // "Hoymiles",
    "HUAWEI",
    // "INVT",
    "SMA",
    // "SOFAR",
    "SOLAREDGE",
    // "SOLARK",
    // "SOLAX",
    // "SOLIS",
    // "SOLPLANET",
    "SUNGROW",
    // "SUNSYNK",
    // "TESLA",
    // "TSUN",
];

export const SUPPORTED_INVERTER_VENDORS = [...ENODE_SUPPORTED_INVERTER_VENDORS, 'SUNGROW-AUSTRALIA'];